// Inject global CSS for SweetAlert2 z-index override once
if (!document.getElementById('swal-zindex-style')) {
  const style = document.createElement('style');
  style.id = 'swal-zindex-style';
  style.innerHTML = `
    .swal2-container {
      z-index: 3000 !important;
    }
  `;
  document.head.appendChild(style);
}

import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Box, Modal, Typography, IconButton, Button, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ModifyReservationModal = ({ booking, open, onClose, onSubmit }) => {
  const [checkIn, setCheckIn] = useState(booking?.checkIn?.split('T')[0]);
  const [checkOut, setCheckOut] = useState(booking?.checkOut?.split('T')[0]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async () => {
    if (new Date(checkOut) <= new Date(checkIn)) {
      alert("Check-out date must be after check-in date.");
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await onSubmit({
        checkIn,
        checkOut,
        strictMode: true
      });

      if (result?.success === false && result.message) {
        Swal.fire({
          icon: 'error',
          title: 'Failed to update',
          text: result.message,
          confirmButtonColor: '#A58E63',
          customClass: {
            popup: 'swal2-zindex-override'
          }
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 500,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Typography variant="h6">Modify Reservation</Typography>
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </Box>

        <TextField
          label="Check-in"
          type="date"
          fullWidth
          value={checkIn}
          onChange={(e) => setCheckIn(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ mb: 3 }}
        />

        <TextField
          label="Check-out"
          type="date"
          fullWidth
          value={checkOut}
          onChange={(e) => setCheckOut(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />

        <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
          <Button onClick={onClose} variant="outlined">Cancel</Button>
          <Button
            onClick={handleSave}
            variant="contained"
            disabled={isSubmitting}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              textTransform: 'uppercase'
            }}
          >
            {isSubmitting && (
              <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
            )}
            {isSubmitting ? 'Saving...' : 'Save'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModifyReservationModal;